module.exports = __webpack_public_path__ + "static/Verne2-bc5e197471fba0fc19c66b6deeb65e68.webp";